import { WhyAhmData } from './index';

const whyAhmData: WhyAhmData = [
  {
    description:
      'We take a fresh approach to health insurance and cut out the complexity. Everything we do is about making things simpler, so you can make the most of what matters to you.',
    heading: 'Straightforward',
  },
  {
    description:
      'Just let us know within 30 days of joining and as long as you haven’t made any claims we’ll refund your premiums. Simple.',
    heading: '30 day cooling off period',
  },
  {
    description:
      'It takes less than 3 minutes to join ahm, but who’s counting? Just have your Medicare card and payment details ready to go.',
    heading: 'Join online',
  },
];

export default whyAhmData;
